/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data:{
        post_id:qk_global.post_id,
    },
    methods:{
        report(e){ 
            if(!qktoken) return this.$createModal('login');
            this.$createModal("report",{
                //keepAlive:false,
                props:{
                    post_id:this.post_id
                }
            })
        },
    }
};
